import type {
    CuratedItem,
    CuratedStory,
    Eyebrow,
    InfoData,
    RelatedItem,
} from "~types/types";
import { getBrandEyebrowData } from "~utils/brands";
import { capitalize } from "~utils/capitalize";
import { getFranchiseEyebrowData } from "~utils/franchises";
import { getLabelEyebrowData } from "~utils/labels";
import replaceWithSpaces from "~utils/replaceWithSpaces";

const OPINION_EYEBROWS = ["opinion", "view", "gadfly", "bview"];

export const isOpinion = (brand?: string, franchise?: string) => {
    if (franchise && OPINION_EYEBROWS.includes(franchise)) {
        return true;
    }

    if (brand && OPINION_EYEBROWS.includes(brand)) return true;
    return false;
};

export const isOpinionItem = (item: CuratedItem | RelatedItem) => {
    const story = item as CuratedStory | RelatedItem;
    if (story.franchise && OPINION_EYEBROWS.includes(story.franchise)) {
        return true;
    }

    if (story.brand && OPINION_EYEBROWS.includes(story.brand)) return true;
    return false;
};

export function eyebrow(item: CuratedStory) {
    const { brand, franchise, label } = item;
    const bybrowEligible = isOpinion(brand, franchise);

    if (label) {
        return {
            data: eyebrowDataGenerator(
                getLabelEyebrowData(item),
                label,
                bybrowEligible,
                true
            ),
        };
    }

    if (franchise) {
        return {
            data: eyebrowDataGenerator(
                getFranchiseEyebrowData(item),
                franchise,
                bybrowEligible
            ),
        };
    }

    if (brand) {
        return {
            data: eyebrowDataGenerator(
                getBrandEyebrowData(item),
                brand,
                bybrowEligible
            ),
        };
    }

    return null;
}

export function eyebrowDataGenerator(
    data: InfoData,
    defaultEyebrow: string,
    bybrowEligible: boolean,
    isLabel = false
): Eyebrow {
    const fallbackEyebrow = isLabel
        ? defaultEyebrow
        : capitalize(replaceWithSpaces(defaultEyebrow));
    const eyebrowName = data.name || fallbackEyebrow;

    return {
        url: data.url || "",
        text: eyebrowName || "",
        bybrowEligible,
    };
}
